import ModernEditor from './ModernEditor';

/**
 * Legacy wrapper for the new TipTap-based ModernEditor.
 * This ensures all existing components (LessonPlanEditor, ContentManager, etc.)
 * get the new premium UI/UX without requiring import changes.
 */
const RichTextEditor = (props) => {
    return <ModernEditor {...props} readOnly={props.readOnly} />;
};

export default RichTextEditor;
